import { render, staticRenderFns } from "./SidePanelRatesAdmin.vue?vue&type=template&id=6f512be2&scoped=true&"
import script from "./SidePanelRatesAdmin.vue?vue&type=script&lang=js&"
export * from "./SidePanelRatesAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelRatesAdmin.vue?vue&type=style&index=0&id=6f512be2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f512be2",
  null
  
)

export default component.exports